import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  type ToggleButtonGroupProps,
} from "@mui/material";

export function ToggleButtonGroup(props: ToggleButtonGroupProps) {
  return <MuiToggleButtonGroup {...props} />;
}
